import React from 'react';
import Nav from '../MEP/SWNav';
import RiAg from '../../assets/DiagoRisk/risques-agricoles.png'
import Mains from '../../assets/Site_Web/equipe-diagorisk.jpg'
import FooterSW from '../MEP/footer_SW';

function QuiSommesNous() {
  return (
    <div>
      <Nav/>
      <div className="containerSW" >
        <div className='row'><img src={RiAg} alt="Logo RisquesAgricoles" className="RiAg"/></div>
        <div className='paragraphe paragrapheLanding' style={{width:'85%', margin:"30px auto"}}>DiagoRisk est développé par RisquesAgricoles SAS, une start-up innovante fondée par 5 associés expérimentés (agronome, actuaires, informaticiens). Nous associons une modélisation actuarielle exploitant plus de 20 ans de données, une connaissance métiers approfondie et la capacité à rendre ces résultats facilement accessible grâce au numérique.</div>
        <div className='principal' style={{marginTop:'20px'}}>
          <div className='top topBis'> 
            <img src={Mains} alt="Image de plusieurs mains posées sur un tronc d'arbre" className="Mains"/>
          </div>
          <div className='bottom bottom2' style={{marginTop:'0px'}}>
            <div className='titre'>Equipe :</div>
            <div className='titreMoins lighter'>Luc BOUCHER</div>
            <div className='titreMoinsMoins'>Directeur</div>
            <div className='QSM_p'>Ingénieur agronome (Rennes 88), ing. Civil du Gref (AgroParisTech 1990-92) spécialisé en gestion des risques en agriculture</div>
            
            <div className='titreMoins lighter'>Martial PHELIPPE-GUINVARC’H</div>
            <div className='titreMoinsMoins'>Actuaire Sénior, conception modèle</div>
            <div className='QSM_p'>Maitre de Conférences à l’Institut du Risque et de l’Assurance, Le Mans Université.</div>
            
            <div className='titreMoins lighter'>Rémi PIGUET-LACROIX</div>
            <div className='titreMoinsMoins'>Actuaire Sénior</div>
            
            <div className='titreMoins lighter'>Charly BOURGEOIS</div>
            <div className='titreMoinsMoins'>Ingénieur informatique, développeur Back-End</div>
            <div className='QSM_p'> Ingénieur INSA </div>
            
            <div className='titreMoins lighter'>Aliénor MEYER-MASSONNET</div>
            <div className='titreMoinsMoins'>Cheffe de produit, développeuse Front-End</div>
            <div className='QSM_p'>Ingénieur agronome spécialité AgroTIC : Technologies de l’Information et de la Communication pour l’Agriculture et l’Environnement (Bordeaux Sciences Agro)</div>
          
            <div className='titreMoins lighter'>Pablo YEPES LLANO</div>
            <div className='titreMoinsMoins'>Data Scientist</div>
            <div className='QSM_p'>Economiste, spécaliste en risques et assurances</div>

            <div className='titreMoins lighter'>Clément BOURGADE</div>
            <div className='titreMoinsMoins'>Data Scientist, ingénieur en modélisation</div>
            <div className='QSM_p'>Modélisateur en écologie (Rennes1 2021)</div>
          
          </div>
        </div>
      </div>
      <FooterSW/>
    </div>
  );
}

export default QuiSommesNous;

